<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="column" fxLayoutAlign="space-around stretch" fxFlexFill>
                <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px">
                    <div ngModelGroup="comboParticipacao" fxFlex="65%">
                        <combo-edicao-participante-reuniao [showDisplayId]="false"
                                        [obrigatorio]="false"
                                        [selecionado]="participanteReuniao"
                                        [label]="'Participante'"
                                        [campoPesquisavel]="'nome'"
                                        (valorChange)="onNomeParticipanteChangeReuniao($event)"
                                        >
                        </combo-edicao-participante-reuniao>
                    </div>

                    <mat-form-field fxFlex="35%">
                        <mat-label>Empresa/Departamento:</mat-label>
                        <input matInput name="empresa" placeholder="Origem" [(ngModel)]="participanteReuniao.origem" maxlength="200">
                    </mat-form-field>
                
                </div>

            </div>
        </form>
    </div>
</div>

<div dir="rtl" fxLayout="row" fxLayoutAlign="center center"
     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
     fxFlexFill>

        <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary" [disabled]=formConsultar.invalid
            (click)="adicionar()">
            Adicionar
        </button>

        <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="cancelar()">
            Cancelar
        </button>

        <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            [disabled]=formConsultar.invalid (click)="atualizar()">
            Atualizar
        </button>

</div>
